import {api} from "../../services";
import {v4 as uuidv4} from 'uuid'
import Swal from "sweetalert2";

const me = {
  state: {
    error_login: {},
    error_recovery: null,
    login: {
      user: {
        email: null,
        password: null,
        language_key: null,
        info: []
      },
    },
    recovery: {
      step: 1,
      user: {
        email: null,
        password: null,
        name: null,
        token: null,
        user_id: null
      },
    },
    confirm_email: {
      step: 1,
    },
    confirm_whatsapp: {
      step: 1,
    },
    temp_lang: null,
    data: [],
    user: {},
    user_ip: [],
    voip: {
      status: 0,
      logged: false,
      minutes: '00',
      seconds: '00',
      mute: false,
      media: false,
      lead: {},
      config: {
        mediaDevices: {
          videoinput: {
            enabled: false,
          },
        },
        userAgent: {
          renderTargets: ['user_agent'],
          transport: {
            sockets: [`wss://appbee.api4com.com:7443`],
            recovery_max_interval: 30,
            recovery_min_interval: 2,
          },
          authentication: {
            username: null,
            // username: '1000@appbee.api4com.com',
            password: null,
            // password: '1000',
            realm: 'appbee.api4com.com',
          },
          user_agent: {
            instance_id: uuidv4(),
            no_answer_timeout: 30,
            register: true,
            register_expires: 3600, // 1h
            user_agent: 'api4com-libwebphone',
          },
        },
      }
    },
    register: {
      name: null,
      email: null,
      password: null,
      channel_type_key: null,
      company_name: null,
      address: null
    }
  },
  mutations: {
    SET_ERROR(state, payload) {
      state.error_login = payload
    },
    SET_ERROR_RECOVERY(state, payload) {
      state.error_recovery = payload
    },
    SET_ME(state, payload) {
      state.data = payload
    },
    SET_ME_LANG(state, payload) {
      state.temp_lang = parseInt(payload)
      state.login.user.language_key = parseInt(payload)
    },
    SET_IP(state, payload) {
      state.login.user.info = payload
    },
    SET_RECOVERY_STEP(state, payload) {
      state.recovery.step = payload
    },
    SET_RECOVERY(state, payload) {
      state.recovery.user = payload
    },
    SET_STEP_CONFIRM_EMAIL(state, payload) {
      state.confirm_email.step = payload
    },
    SET_STEP_CONFIRM_WHATSAPP(state, payload) {
      state.confirm_whatsapp.step = payload
    },
  },
  actions: {
    async getMe(context) {
      api.post(`/auth/me`).then(async response => {
        context.commit("SET_ME", response.data);
        await this.dispatch('getConfigs')
        await this.dispatch('getChannelsAll');
        await this.dispatch('getDepartmentsAll');
        await this.dispatch('getInterestsAll');
        await this.dispatch('getMotivesAll');
        await this.dispatch('getOperatorsAll');
        await this.dispatch('getRepliesAll');
        await this.dispatch('getTagsAll');
        await this.dispatch('getUsersAll');
        await this.dispatch('getLeadTagsAll');
        await this.dispatch('getNotifications');
        await this.dispatch('getNotificationsCount');
        await this.dispatch('getConversations');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },

    getReloadLang(context, payload) {
      this.dispatch('getConfigs')
      this.dispatch('getMe');

      // Atualiza informações do dash
      if (payload.channel_id) {
        this.dispatch('getDashboardInfo', {
          channel_id: payload.channel_id,
        })
      }
    },

    /* AUTH */
    loginUser(context, payload) {
      // Armazena preferencia de idioma
      const temp_lang = window.localStorage.getItem("temp_lang")
      api.post(`/auth/login`, payload).then(response => {
        window.localStorage.access_token = response.data.access_token
        window.location = "/";
      }).catch(error => {
        window.localStorage.clear()
        context.commit("SET_ME", {})
        context.commit("SET_ERROR", null)
        context.commit("SET_ERROR", error.response.data)
        // Seta preferencia de idioma no LS
        window.localStorage.setItem("temp_lang", temp_lang)
      });
    },
    logoutUser(context) {
      this.dispatch('startLoading');
      // Armazena preferencia de idioma
      const temp_lang = window.localStorage.getItem("temp_lang")
      api.post(`/auth/logout`).then(() => {
        window.localStorage.clear()
        context.commit("SET_ME", {})
        // Seta preferencia de idioma no LS
        window.localStorage.setItem("temp_lang", temp_lang)
        window.location = "/login";
      }).catch(error => {
        window.localStorage.clear()
        context.commit("SET_ME", {})
        // Seta preferencia de idioma no LS
        window.localStorage.setItem("temp_lang", temp_lang)
        window.location = "/login";
      });
    },

    /* RECOVERY */
    forgetPassword(context, payload) {
      // Armazena preferencia de idioma
      const temp_lang = window.localStorage.getItem("temp_lang")
      api.post(`/auth/forget-password`, payload).then(() => {
        context.commit("SET_RECOVERY_STEP", 2)
        // window.location = "/login";
      }).catch(error => {
        window.localStorage.clear()
        if (error.response.status === 404 || error.response.status === 422) {
          context.commit("SET_ERROR_RECOVERY", context.rootGetters.getTranslations('expression_936'))
        }
        // Seta preferencia de idioma no LS
        window.localStorage.setItem("temp_lang", temp_lang)
      });
    },
    confirmTokenForgetPassword(context, payload) {
      // Armazena preferencia de idioma
      const temp_lang = window.localStorage.getItem("temp_lang")
      api.post(`/auth/confirm-token-forget-password`, payload).then((response) => {
        context.commit("SET_RECOVERY_STEP", 3)
        context.commit("SET_RECOVERY", response.data)
      }).catch(error => {
        window.localStorage.clear()
        if (error.response.status === 404 || error.response.status === 422) {
          context.commit("SET_RECOVERY", {})
          context.commit("SET_ME", {})
          context.commit("SET_RECOVERY_STEP", 4)
        }
        // Seta preferencia de idioma no LS
        window.localStorage.setItem("temp_lang", temp_lang)
      });
    },
    updatePassword(context, payload) {
      // Armazena preferencia de idioma
      const temp_lang = window.localStorage.getItem("temp_lang")
      api.post(`/auth/update-password`, payload).then((response) => {
        context.commit("SET_RECOVERY_STEP", 5)
      }).catch(error => {
        window.localStorage.clear()
        if (error.response.status === 404 || error.response.status === 422) {
          context.commit("SET_RECOVERY", {})
          context.commit("SET_ME", {})
          context.commit("SET_RECOVERY_STEP", 4)
        }
        // Seta preferencia de idioma no LS
        window.localStorage.setItem("temp_lang", temp_lang)
      });
    },
    confirmEmail(context, payload) {
      api.post(`/auth/confirm-email`, payload).then(() => {
        Swal.fire(
          `${context.rootGetters.getTranslations('expression_939')}`,
          `${context.rootGetters.getTranslations('expression_937')}
                    <br/>
                    <small>${context.rootGetters.getTranslations('expression_938')}</small>`,
          'success'
        )
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },
    confirmTokenEmailVerified(context, payload) {
      api.post(`/auth/confirm-token-email-verified`, payload).then(response => {
        window.localStorage.setItem('confirm_user_id', response.data.id)
        context.commit("SET_STEP_CONFIRM_EMAIL", 2)
      }).catch(() => {
        context.commit("SET_STEP_CONFIRM_EMAIL", 3)
      });
    },
    confirmWhatsApp(context, payload) {
      api.post(`/auth/confirm-whatsapp`, payload).then(() => {
        Swal.fire(
          `${'Link enviado!'}`,
          `${'Enviamos uma mensagem para o seu número de WhatsApp com um link de confirmação da sua conta.'}
                <br/>
                <small>${'Falta pouco para você ter acesso ao BEECRM. Essa é a última etapa de confimação.'}</small>`,
          'success'
        ).then(() => {
          window.localStorage.removeItem('confirm_user_id')
          setTimeout(() => {
            window.router.push({name: 'Login'})
          }, 300)
        })
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },
    confirmTokenWhatsAppVerified(context, payload) {
      api.post(`/auth/confirm-token-whatsapp-verified`, payload).then(response => {
        window.localStorage.setItem('confirm_user_id', response.data.id)
        context.commit("SET_STEP_CONFIRM_WHATSAPP", 2)
      }).catch(() => {
        context.commit("SET_STEP_CONFIRM_WHATSAPP", 3)
      });
    },

    // REGISTRO
    userRegister(context, payload) {
      api.post(`/auth/register`, payload).then(response => {
        Swal.fire(
          `${'Usuário cadastrado com sucesso!'}`,
          `${context.rootGetters.getTranslations('expression_937')}
                <br/>
                <small>${'Você só terá acesso ao sistema após as confirmações necessárias.'}</small>`,
          'success'
        ).then(() => {
          setTimeout(() => {
            window.router.push({name: 'Login'})
          }, 400)
        })
      }).catch(error => {
        if (error.response.status === 400) {
          if (error.response.data.user.deleted_at) {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: "Esse usuário já foi cadastrado anteriormente. Por favor, contacte nosso suporte.",
              showConfirmButton: true
            })
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: "Esse usuário já está cadastrado! Por favor, faça login com seu e-mail e senha.",
              showConfirmButton: true
            }).then(() => {
              setTimeout(() => {
                window.router.push({name: 'Login'})
              }, 400)
            })
          }
        }
      });
    },
  },
}
export default me;
